const AccordionExpanded = 'ACCORDION_EXPANDED';
const GeneralAccordionExpanded = 'GENERAL_DETAIL_ACCORDION_EXPANDED';
const UpdatePasswordLoaded = 'UPDATE_PASSWORD_FORM_LOADED';
const UpdatePasswordSubmitClicked = 'UPDATE_PASSWORD_SUBMIT_CLICKED';
const UpdatePasswordSubmitCtaError = 'UPDATE_PASSWORD_SUBMIT_CTA_ERROR';
const BusinessBankDetailsAccordionExpanded = 'BUSINESS_BANK_DETAILS_ACCORDION_EXPANDED';
const ResellerRegistrationTypeSelected = 'RESELLER_REGISTRATION_TYPE_SELECTED';
const ResellerGstinFilled = 'RESELLER_GSTIN_FILLED';
const ResellerProfileSubmitClicked = 'RESELLER_PROFILE_SUBMIT_CLICKED';
const ResellerProfileSubmitCtaError = 'RESELLER_PRFILE_SUBMIT_CTA_ERROR';
const ReferralLinkCopied = 'AFFILIATE_LINK_COPIED';

export default {
  AccordionExpanded,
  GeneralAccordionExpanded,
  UpdatePasswordLoaded,
  UpdatePasswordSubmitClicked,
  UpdatePasswordSubmitCtaError,
  BusinessBankDetailsAccordionExpanded,
  ResellerRegistrationTypeSelected,
  ResellerGstinFilled,
  ResellerProfileSubmitClicked,
  ResellerProfileSubmitCtaError,
  ReferralLinkCopied,
};
